import { RadioInputClickEvent } from '../../../elements';
import { AccordianAction } from '../types';
import { AccordianSlot } from '../interfaces';
import { useTranslation } from 'react-i18next';
import {
  AccordianProps,
  AccordianState,
  AccordianHandlers,
  AccordianEvent,
} from '../../..';

export function useAccordianEffect(
  props: AccordianProps
): [AccordianState, AccordianHandlers] {
  const { t } = useTranslation();
  const { styleClasses } = props;

  const classes = styleClasses.join(' ');

  const state: AccordianState = {
    classes,
    title: props.title ? (t(props.title) as string) : undefined,
    label: props.label ? (t(props.label) as string) : undefined,
  };

  const onChange = (e: RadioInputClickEvent) => {
    const selectedSlot = props.slots.find(
      (slot) => slot.id === e.detail.id
    ) as AccordianSlot;

    if (!selectedSlot.disabled) {
      const changeDetail = {
        id: e.detail.id,
        value: selectedSlot.value,
        type: 'change' as AccordianAction,
      };

      const changeEvent: AccordianEvent = { detail: changeDetail };

      props.onChangeHandler(changeEvent);
    }
  };

  const onClick = () => {
    if (props.onClickHandler) {
      const clickDetail = {
        id: props.id,
        value: 1,
        type: 'click' as AccordianAction,
      };

      const clickEvent: AccordianEvent = { detail: clickDetail };

      props.onClickHandler(clickEvent);
    }
  };

  const handlers: AccordianHandlers = {
    onChange,
    onClick,
  };

  return [state, handlers];
}
